var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.79 72.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.36 32.3h53.45v29.2H10.36zm1.11 14.84h17.18m17.39 0h16.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.81 61.28V46.79a6.85 6.85 0 0 1 6.85-6.85h2.81a6.85 6.85 0 0 1 6.85 6.85v14.49h0zm-18.45.22H1.92m8.36.67v7.56m-4.01 1.18h8.43m18.93 0h8.44m17.44 0h8.43m-4-8.74v7.56m-26.09-7.56v7.56m34.44-8.23h-8.43M1.5 31.86h69.57v-2.57c0-2.56-1.74-5-4.71-6.51 0 0-17.32-10.51-22.57-14.95S36.27 1.5 36.27 1.5 34.61 3.18 29.79 8 6.36 22.64 6.36 22.64c-3.06 1.54-4.86 4-4.86 6.58z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamp);
export default __webpack_public_path__ + "static/media/camp.ef7a519b377cf2f385ed637572eaa84f.svg";
export { ForwardRef as ReactComponent };